<template>
  <div v-if="banner != null">
    <div id="modalBannerCampaign" class="modal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="text-end">
            <button type="button" class="btn-close p-2 position-absolute end-0" data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body p-0">
            <a href="tel:8668830573">
              <img :src="imageSrc" alt="" class="img-fluid" />
            </a>
            <!-- <img :src="banner[0].image" alt="" class="img-fluid" @click="jivo_openChat()" />
                    <img src="../assets/images/banners/am-btn-shamrock-2023.png" alt="" class="w-75 position-absolute btn-banner" @click="jivo_openChat()"> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <img
      id="mainBanner"
      :src="require(`@/assets/images${this.banner}`)"
      style="z-index: 2000; max-height: 750px"
      class="fixed-top h-100 py-3 mx-auto d-none"
      @click="hideBanner"
    /> -->
  </div>
</template>
<script>
import store from "@/store.js";

export default {
  data() {
    return {
      banner: store.website.banners,
      now: new Date(),
      imageSrc: null
    };
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#modalBannerCampaign');
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    jivo_openChat() {
      /*eslint no-undef: "error"*/
      // eslint-disable-next-line
      jivo_api.open()
    },
    getImageByCampaign(campaign) {
      switch (campaign) {
        case 'labor-day-2025':
          return (this.banner[1].image);
        case 'day-of-d':
          return (this.banner[0].image);
        default:
          return (this.banner[0].image);
      }
    }
  },
  mounted() {
    if (store.website.banners[0].fromDate < this.now && store.website.banners[0].toDate > this.now || this.$route.query.campaign=='spring-2026') {
      this.showModal();
    }
    if (store.website.banners[1].fromDate < this.now && store.website.banners[1].toDate > this.now) {
      this.showModal();
    }
  },
  created() {
    const campaign = this.$route.query.campaign; // leer query ?campaign=abc
    this.imageSrc = this.getImageByCampaign(campaign);
  },
};
</script>

<style>
.btn-close {
  opacity: 1 !important;
  z-index: 1 !important;
  background-color: white !important;
}

.btn-banner {
  left: 13%;
  margin-top: 113%;
}

.modal-body {
  cursor: pointer;
}
</style>
